import { render, staticRenderFns } from "./AnswerHistory.vue?vue&type=template&id=15c22b0a&scoped=true"
import script from "./AnswerHistory.vue?vue&type=script&lang=js"
export * from "./AnswerHistory.vue?vue&type=script&lang=js"
import style0 from "./AnswerHistory.vue?vue&type=style&index=0&id=15c22b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c22b0a",
  null
  
)

export default component.exports